import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, Stack, Typography } from "@mui/material";
import ChatInputV2 from "components/chat-v2/ChatInputV2";
import { useTheme } from "@emotion/react";
import ConversationMessages from "components/chat-v2/ConversationMessages";
import { useNavigate, useParams } from "react-router-dom";

export default function ConversationV2() {
  const params = useParams();
  const conversationId = params.conversationId;
  const navigate = useNavigate();

  const theme = useTheme();
  const auth = useAuth();
  const uid = auth.currentUser?.uid;
  const botState = useSelector((state) => state.bot);
  const bot = botState.idMap[botState.current];
  const contextSize = botState.contextSize;

  const modelsState = useSelector((state) => state.collections.models);
  const modelData =
    modelsState && !modelsState.loading && bot
      ? modelsState.idMap[bot.model]
      : null;
  const isImage = modelData && modelData.type.endsWith("/image");

  useEffect(() => {
    navigate("/");
  }, [botState.current]);

  const renderConversation = () => {
    if (uid && conversationId) {
      return <ConversationMessages uid={uid} contextSize={contextSize} />;
    }
    if (!isImage) {
      return (
        <Typography
          fontFamily="'Anton', serif"
          variant="h6"
          color="text"
          sx={{
            color: theme.palette.text.primary,
          }}
        >
          What do you want to chat about ?
        </Typography>
      );
    }
    return null;
  };

  return (
    <Stack
      spacing={1}
      alignItems="center"
      justifyContent="center"
      sx={{
        boxSizing: "border-box",
        width: "100%",
        height: "100%",
      }}
      px={3}
      py={2}
    >
      {renderConversation()}
      {isImage && (
        <Stack
          spacing={1}
        >
          <Typography
            fontFamily="'Anton', serif"
            variant="h6"
            color="text"
            sx={{
              color: theme.palette.text.primary,
            }}
          >
            Image generation was migrated to the Image Studio.
          </Typography>
          <Button onClick={() => navigate("/images")} variant="contained">Open Image Studio</Button>
        </Stack>
      )}
      {!isImage && (
        <ChatInputV2
          placeholder={"How can I help you?..."}
          sx={{
            zIndex: 3,
            width: "100%",
          }}
          color="secondary"
        />
      )}
    </Stack>
  );
}
